import {
  createWebHistory,
  createRouter,
  createWebHashHistory,
} from "vue-router";
// import {useAuthStore} from  "@/services/auth"
// import ApiService from "@/services/ApiService";

// Layouts
// import MainLayout from "@/layouts/MainLayout.vue";

import MaintenancePage from "../pages/PagesInner/MaintenancePage.vue";
import ConnectedAccountsPage from "../pages/PagesInner/ConnectedAccountsPage.vue";
import LogoutPage from "../pages/LogoutPage.vue";
import ListePermissionPage from "@/pages/Permission/ListePermissionPage.vue";
import AddRolePage from "@/pages/Role/AddRolePage.vue";
import EditRolePage from "@/pages/Role/EditRolePage.vue";
import ListeRolePage from "@/pages/Role/ListeRolePage.vue";
import ViewRolePage from "@/pages/Role/ViewRolePage.vue";
import AddUserPage from "@/pages/Users/AddUserPage.vue";
import EditUserPage from "@/pages/Users/EditUserPage.vue";
import ViewUserPage from "@/pages/Users/ViewUserPage.vue";
import ListeUserPage from "@/pages/Users/ListeUserPage.vue";

import EcommercePage from "../pages/Dashboard/EcommercePage.vue";
import ProjectManagementPage from "../pages/Dashboard/ProjectManagementPage.vue";
import SupportDeskPage from "../pages/Dashboard/SupportDeskPage.vue";
import LMSCoursesPage from "../pages/Dashboard/LMSCoursesPage.vue";
import CRMSystemPage from "../pages/Dashboard/CRMSystemPage.vue";
import FileManagerPage from "../pages/FileManagerPage.vue";
import ChangelogPage from "../pages/ChangelogPage.vue";
import CalendarPage from "../pages/CalendarPage.vue";
import ChatPage from "../pages/ChatPage.vue";
import ChatGroupPage from "../pages/ChatGroupPage.vue";
import ChatContactPage from "../pages/ChatContactPage.vue";
import LeadsPage from "../pages/CRM/LeadsPage.vue";
import LeadDetailsPage from "../pages/CRM/LeadDetailsPage.vue";
import ContactsListPage from "../pages/CRM/ContactsListPage.vue";
import CustomersListPage from "../pages/CRM/CustomersListPage.vue";
import EmailsPage from "../pages/Emails/EmailsPage.vue";
import ReadEmailPage from "../pages/Emails/ReadEmailPage.vue";
import ProductsGridPage from "../pages/Ecommerce/ProductsGridPage.vue";
import ProductsListPage from "../pages/Ecommerce/ProductsListPage.vue";
import AddProductPage from "../pages/Ecommerce/AddProductPage.vue";
import ProductDetailsPage from "../pages/Ecommerce/ProductDetailsPage.vue";
import OrdersListPage from "../pages/Ecommerce/OrdersListPage.vue";
import OrderDetailsPage from "../pages/Ecommerce/OrderDetailsPage.vue";
import ShoppingCartPage from "../pages/Ecommerce/ShoppingCartPage.vue";
import CheckoutPage from "../pages/Ecommerce/CheckoutPage.vue";
import CustomersPage from "../pages/Ecommerce/CustomersPage.vue";
import SellersListPage from "../pages/Ecommerce/SellersListPage.vue";
import ManageReviewsPage from "../pages/Ecommerce/ManageReviewsPage.vue";
import RefundPage from "../pages/Ecommerce/RefundPage.vue";
import InvoiceListPage from "../pages/Ecommerce/InvoiceListPage.vue";
import InvoiceDetailsPage from "../pages/Ecommerce/InvoiceDetailsPage.vue";
import OrderTrackingPage from "../pages/Ecommerce/OrderTrackingPage.vue";
import CoursesListPage from "../pages/ELearning/CoursesListPage.vue";
import CoursesGridPage from "../pages/ELearning/CoursesGridPage.vue";
import CourseDetailsPage from "../pages/ELearning/CourseDetailsPage.vue";
import LessonsPreviewPage from "../pages/ELearning/LessonsPreviewPage.vue";
import EditCoursePage from "../pages/ELearning/EditCoursePage.vue";
import ListViewPage from "../pages/SupportDesk/ListViewPage.vue";
import CardViewPage from "../pages/SupportDesk/CardViewPage.vue";
import ContactsPage from "../pages/SupportDesk/ContactsPage.vue";
import TicketPreviewPage from "../pages/SupportDesk/TicketPreviewPage.vue";
import ProjectsListPage from "../pages/Projects/ProjectsListPage.vue";
import ProjectsGridPage from "../pages/Projects/ProjectsGridPage.vue";
import CreateNewProjectPage from "../pages/Projects/CreateNewProjectPage.vue";
import ProjectDetailsPage from "../pages/Projects/ProjectDetailsPage.vue";
import ToDoListPage from "../pages/Projects/ToDoListPage.vue";
import TeamsPage from "../pages/Projects/TeamsPage.vue";
import KanbanPage from "../pages/KanbanPage.vue";
import EventsGridPage from "../pages/Events/EventsGridPage.vue";
import EventDetailsPage from "../pages/Events/EventDetailsPage.vue";
import TimelinePage from "../pages/Social/TimelinePage.vue";
import AboutPage from "../pages/Social/AboutPage.vue";
import ActivityPage from "../pages/Social/ActivityPage.vue";
import ProfileSettingsPage from "../pages/Social/ProfileSettingsPage.vue";
import StarterPage from "../pages/StarterPage.vue";
import LoginPage from "../pages/Authentication/LoginPage.vue";
import RegisterPage from "../pages/Authentication/RegisterPage.vue";
import ForgotPasswordPage from "../pages/Authentication/ForgotPasswordPage.vue";
import ResetPasswordPage from "../pages/Authentication/ResetPasswordPage.vue";
import EmailConfirmationPage from "../pages/Authentication/EmailConfirmationPage.vue";
import UsersListPage from "../pages/Users/UsersListPage.vue";
import PricingPage from "../pages/PricingPage.vue";
import FaqPage from "../pages/FaqPage.vue";
import SwiperSliderPage from "../pages/Miscellaneous/SwiperSliderPage.vue";
import PrivacyPolicyPage from "../pages/Miscellaneous/PrivacyPolicyPage.vue";
import TermsConditionsPage from "../pages/Miscellaneous/TermsConditionsPage.vue";
import FormOverviewPage from "../pages/Forms/FormOverviewPage.vue";
import FormControlPage from "../pages/Forms/FormControlPage.vue";
import FormSelectPage from "../pages/Forms/FormSelectPage.vue";
import FormChecksRadiosPage from "../pages/Forms/FormChecksRadiosPage.vue";
import FormRangePage from "../pages/Forms/FormRangePage.vue";
import FormInputGroupPage from "../pages/Forms/FormInputGroupPage.vue";
import FormFloatingLabelsPage from "../pages/Forms/FormFloatingLabelsPage.vue";
import FormLayoutPage from "../pages/Forms/FormLayoutPage.vue";
import FormValidationPage from "../pages/Forms/FormValidationPage.vue";
import FormWizardPage from "../pages/Forms/FormWizardPage.vue";
import ErrorPage from "../pages/ErrorPage.vue";
import TablesPage from "../pages/TablesPage.vue";
import ChartsPage from "../pages/Charts/ChartsPage.vue";
import MixedChartsPage from "../pages/Charts/MixedChartsPage.vue";
import FlaticonsPage from "../pages/Icons/FlaticonsPage.vue";
import PhosphoriconsPage from "../pages/Icons/PhosphoriconsPage.vue";
import GoogleMapsPage from "../pages/Maps/GoogleMapsPage.vue";
import LeafletMapPage from "../pages/Maps/LeafletMapPage.vue";
import TreePage from "../pages/ExtendedUI/TreePage.vue";
import EditorsPage from "../pages/ExtendedUI/EditorsPage.vue";
import AccordionPage from "../pages/UIElements/AccordionPage.vue";
import AlertsPage from "../pages/UIElements/AlertsPage.vue";
import AvatarsPage from "../pages/UIElements/AvatarsPage.vue";
import BadgesPage from "../pages/UIElements/BadgesPage.vue";
import BreadcrumbPage from "../pages/UIElements/BreadcrumbPage.vue";
import ButtonsPage from "../pages/UIElements/ButtonsPage.vue";
import ButtonGroupPage from "../pages/UIElements/ButtonGroupPage.vue";
import CarouselPage from "../pages/UIElements/CarouselPage.vue";
import CloseButtonPage from "../pages/UIElements/CloseButtonPage.vue";
import ColorBackgroundPage from "../pages/UIElements/ColorBackgroundPage.vue";
import ColoredLinksPage from "../pages/UIElements/ColoredLinksPage.vue";
import CollapsePage from "../pages/UIElements/CollapsePage.vue";
import DropdownsPage from "../pages/UIElements/DropdownsPage.vue";
import DatepickerPage from "../pages/UIElements/DatepickerPage.vue";
import FiguresPage from "../pages/UIElements/FiguresPage.vue";
import IconLinkPage from "../pages/UIElements/IconLinkPage.vue";
import ListGroupPage from "../pages/UIElements/ListGroupPage.vue";
import ModalPage from "../pages/UIElements/ModalPage.vue";
import NavsTabsPage from "../pages/UIElements/NavsTabsPage.vue";
import OffcanvasPage from "../pages/UIElements/OffcanvasPage.vue";
import PaginationPage from "../pages/UIElements/PaginationPage.vue";
import PlaceholdersPage from "../pages/UIElements/PlaceholdersPage.vue";
import PopoversPage from "../pages/UIElements/PopoversPage.vue";
import ProgressPage from "../pages/UIElements/ProgressPage.vue";
import RatioPage from "../pages/UIElements/RatioPage.vue";
import ScrollspyPage from "../pages/UIElements/ScrollspyPage.vue";
import StacksPage from "../pages/UIElements/StacksPage.vue";
import SpinnersPage from "../pages/UIElements/SpinnersPage.vue";
import UITablesPage from "../pages/UIElements/UITablesPage.vue";
import ToastsPage from "../pages/UIElements/ToastsPage.vue";
import UiTimelinePage from "../pages/UIElements/UiTimelinePage.vue";
import TimepickerPage from "../pages/UIElements/TimepickerPage.vue";
import TooltipsPage from "../pages/UIElements/TooltipsPage.vue";
import TypographyPage from "../pages/UIElements/TypographyPage.vue";
import BackgroundPage from "../pages/Utilities/BackgroundPage.vue";
import BordersPage from "../pages/Utilities/BordersPage.vue";
import ColorsPage from "../pages/Utilities/ColorsPage.vue";
import ClearfixPage from "../pages/Utilities/ClearfixPage.vue";
import DisplayPage from "../pages/Utilities/DisplayPage.vue";
import FlexPage from "../pages/Utilities/FlexPage.vue";
import FloatPage from "../pages/Utilities/FloatPage.vue";
import FocusRingPage from "../pages/Utilities/FocusRingPage.vue";
import GridPage from "../pages/Utilities/GridPage.vue";
import GuttersPage from "../pages/Utilities/GuttersPage.vue";
import InteractionsPage from "../pages/Utilities/InteractionsPage.vue";
import LinkPage from "../pages/Utilities/LinkPage.vue";
import ObjectFitPage from "../pages/Utilities/ObjectFitPage.vue";
import OpacityPage from "../pages/Utilities/OpacityPage.vue";
import OverflowPage from "../pages/Utilities/OverflowPage.vue";
import PositionPage from "../pages/Utilities/PositionPage.vue";
import ShadowsPage from "../pages/Utilities/ShadowsPage.vue";
import SizingPage from "../pages/Utilities/SizingPage.vue";
import SpacingPage from "../pages/Utilities/SpacingPage.vue";
import TextPage from "../pages/Utilities/TextPage.vue";
import TextTruncationPage from "../pages/Utilities/TextTruncationPage.vue";
import VerticalAlignmentPage from "../pages/Utilities/VerticalAlignmentPage.vue";
import VerticalRulePage from "../pages/Utilities/VerticalRulePage.vue";
import VisuallyHiddenPage from "../pages/Utilities/VisuallyHiddenPage.vue";
import VisibilityPage from "../pages/Utilities/VisibilityPage.vue";
import ZIndexPage from "../pages/Utilities/ZIndexPage.vue";
import CardsPage from "../pages/Widgets/CardsPage.vue";
import GalleryPage from "../pages/PagesInner/GalleryPage.vue";
import NotificationsPage from "../pages/PagesInner/NotificationsPage.vue";
import ProfilePage from "../pages/PagesInner/ProfilePage.vue";

import BlankPage from "../pages/BlankPage.vue";

import AddParametrePage from "@/pages/Parametre/AddParametrePage.vue";

import ApiService from "@/services/ApiService";
import { useAuthStore } from "@/services/auth";
import ListeDocumentPage from "@/pages/Document/ListeDocumentPage.vue";
import ListeCompagnie from "@/components/compagnie/ListeCompagnie.vue";
import ListeCompagniePage from "@/pages/Compagnie/ListeCompagniePage.vue";
import ListeVesselPage from "@/pages/Vessel/ListeVesselPage.vue";
import ListeManifestPage from "@/pages/Manifest/ListeManifestPage.vue";
import UploadManifestPage from "@/pages/Manifest/UploadManifestPage.vue";
import ListePortPage from "@/pages/Port/ListePortPage.vue";
import ListePortARisquePage from "@/pages/PortARisque/ListePortARisquePage.vue";
import ListeTableauIMDGPage from "@/pages/TableauIMDG/ListeTableauIMDGPage.vue";
import ListeCategorieHsCodePage from "@/pages/CategorieHsCode/ListeCategorieHsCodePage.vue";
import ListeHsCodePage from "@/pages/HsCode/ListeHsCodePage.vue";
import ListeAgentConsignatairePage from "@/pages/AgentConsignataire/ListeAgentConsignatairePage.vue";
import ViewManifestPage from "@/pages/Manifest/ViewManifestPage.vue";
import ManifestMapPage from "@/pages/Manifest/ManifestMapPage.vue";
import ViewVesselPage from "@/pages/Vessel/ViewVesselPage.vue";
import ViewEquipMarchandPage from "@/pages/Manifest/ViewEquipMarchandPage.vue";
import ListeIncotermPage from "@/pages/Incoterm/ListeIncotermPage.vue";
import AddIncotermPage from "@/pages/Incoterm/AddIncotermPage.vue";
import ListeTarificationPage from "@/pages/Tarification/ListeTarificationPage.vue";
import AddTarificationPage from "@/pages/Tarification/AddTarificationPage.vue";
import AddTypeCargaisonPage from "@/pages/TypeCargaison/AddTypeCargaisonPage.vue";
import ListeTypeCargaisonPage from "@/pages/TypeCargaison/ListeTypeCargaisonPage.vue";
import ListeTypeContainerPage from "@/pages/TypeContainer/ListeTypeContainerPage.vue";
import AddTypeContainerPage from "@/pages/TypeContainer/AddTypeContainerPage.vue";
import AddTypeChargementPage from "@/pages/TypeChargement/AddTypeChargementPage.vue";
import ListeTypeChargementPage from "@/pages/TypeChargement/ListeTypeChargementPage.vue";
import AddTypeFretPaiePage from "@/pages/TypeFretPaiement/AddTypeFretPaiePage.vue";
import ListeTypeFretPaiement from "@/components/TypeFretPaiement/ListeTypeFretPaiement.vue";
import ListeTypeFretPaiePage from "@/pages/TypeFretPaiement/ListeTypeFretPaiePage.vue";
import AddZonePage from "@/pages/Zone/AddZonePage.vue";
import ListeZonePage from "@/pages/Zone/ListeZonePage.vue";
import AddCategoriePPage from "@/pages/CategorieProduit/AddCategoriePPage.vue";
import ListeCategoriePPage from "@/pages/CategorieProduit/ListeCategoriePPage.vue";
import ListeContainerPage from "@/pages/Container/ListeContainerPage.vue";
import AddContainerPage from "@/pages/Container/AddContainerPage.vue";
import AddRegimePage from "@/pages/RegimeDouanier/AddRegimePage.vue";
import ListeRegimePage from "@/pages/RegimeDouanier/ListeRegimePage.vue";
import AddBescPage from "@/pages/BESC/AddBescPage.vue";
import ListeBescPage from "@/pages/BESC/ListeBescPage.vue";
import AddBescStep1Page from "@/pages/BESC/AddBescStep1Page.vue";
import AddBescStep2Page from "@/pages/BESC/AddBescStep2Page.vue";
import AddBescStep3Page from "@/pages/BESC/AddBescStep3Page.vue";
import AddBlStep2Page from "@/pages/BESC/AddBlStep2Page.vue";
import ViewBescPage from "@/pages/BESC/ViewBescPage.vue";
import PaiementPaypalPage from "@/pages/BESC/PaiementPaypalPage.vue";
import PaiementSuccessPage from "@/pages/BESC/PaiementSuccessPage.vue";
import AddValidationTaskPage from "@/pages/ValidationTasks/AddValidationTaskPage.vue";
import ListeValidationTaskPage from "@/pages/ValidationTasks/ListeValidationTaskPage.vue";
import AddValidationQueuePage from "@/pages/ValidationQueue/AddValidationQueuePage.vue";
import ListeValidationQueuePage from "@/pages/ValidationQueue/ListeValidationQueuePage.vue";

import AddValidationCheckPage from "@/pages/ValidationCheck/AddValidationCheckPage.vue";
import ListeValidationCheckPage from "@/pages/ValidationCheck/ListeValidationCheckPage.vue";
import ListeCorrectionRequestPage from "@/pages/CorrectionRequest/ListeCorrectionRequestPage.vue";
import AddCorrectionRequestPage from "@/pages/CorrectionRequest/AddCorrectionRequestPage.vue";
import PaiementStripePage from "@/pages/BESC/PaiementStripePage.vue";
import PaiementMethodePage from "@/pages/BESC/PaiementMethodePage.vue";
import PaiementKKiaPayPage from "@/pages/BESC/PaiementKKiaPayPage.vue";
import AddBlacklistModalPage from "@/pages/RegulatoryBlacklists/AddBlacklistModalPage.vue";
import ListeBlacklistPage from "@/pages/RegulatoryBlacklists/ListeBlacklistPage.vue";
import ListeRuleSetPage from "@/pages/RuleSet/ListeRuleSetPage.vue";
import ListeRulePage from "@/pages/Rule/ListeRulePage.vue";
import ListeProduitRestreintPage from "@/pages/ProduitRestreint/ListeProduitRestreintPage.vue";
import AddRulePage from "@/pages/Rule/AddRulePage.vue";
import AddRuleSetPage from "@/pages/RuleSet/AddRuleSetPage.vue";
import AddProduitRestreintPage from "@/pages/ProduitRestreint/AddProduitRestreintPage.vue";
import ListeTariffZonePage from "@/pages/TariffZone/ListeTariffZonePage.vue";
import AddTariffZonePage from "@/pages/TariffZone/AddTariffZonePage.vue";
import EditTariffZonePage from "@/pages/TariffZone/EditTariffZonePage.vue";
import ViewTariffZonePage from "@/pages/TariffZone/ViewTariffZonePage.vue";
import ListeBescPricingRulePage from "@/pages/BescPricingRule/ListeBescPricingRulePage.vue";
import AddBescPricingRulePage from "@/pages/BescPricingRule/AddBescPricingRulePage.vue";
import EditBescPricingRulePage from "@/pages/BescPricingRule/EditBescPricingRulePage.vue";
import ViewBescPricingRulePage from "@/pages/BescPricingRule/ViewBescPricingRulePage.vue";
import ListePrepaidAccountPage from "@/pages/Compte/ListePrepaidAccountPage.vue";
import AddPrepaidAccountPage from "@/pages/Compte/AddPrepaidAccountPage.vue";
import EditValidationQueuePage from "@/pages/ValidationQueue/EditValidationQueuePage.vue";
import EditValidationCheckPage from "@/pages/ValidationCheck/EditValidationCheckPage.vue";
import EditValidationTaskPage from "@/pages/ValidationTasks/EditValidationTaskPage.vue";
import EditRulePage from "@/pages/Rule/EditRulePage.vue";
import EditCorrectionRequest from "@/components/CorrectionRequest/EditCorrectionRequest.vue";
import EditCorrectionRequestPage from "@/pages/CorrectionRequest/EditCorrectionRequestPage.vue";
import ListeTypeDocumentPage from "@/pages/TypeDocument/ListeTypeDocumentPage.vue";
import AddTypeDocumentPage from "@/pages/TypeDocument/AddTypeDocumentPage.vue";
import AddTypeActeurPage from "@/pages/TypeActeur/AddTypeActeurPage.vue";
import ListeTypeActeurPage from "@/pages/TypeActeur/ListeTypeActeurPage.vue";
import RechargePayPalPage from "@/pages/Compte/RechargePayPalPage.vue";
import RechargeStripePage from "@/pages/Compte/RechargeStripePage.vue";
import RechargeKkiaPayPage from "@/pages/Compte/RechargeKkiaPayPage.vue";
import PrepaidRechargeSuccessPage from "@/pages/Compte/PrepaidRechargeSuccessPage.vue";
import AffectationPage from "@/pages/Affectation/AffectationPage.vue";
import ListeAffectationPage from "@/pages/Affectation/ListeAffectationPage.vue";
import PageSoumissionBescPage from "@/pages/BESC/PageSoumissionBescPage.vue";
import RetirerAgentPage from "@/pages/Affectation/RetirerAgentPage.vue";
import DetailFilePage from "@/pages/File/DetailFilePage.vue";
import EditRuleSetPage from "@/pages/RuleSet/EditRuleSetPage.vue";
import EditProduitRestreintPage from "@/pages/ProduitRestreint/EditProduitRestreintPage.vue";
import RecapitulatifPage from "@/pages/BESC/RecapitulatifPage.vue";
import AgentDashboardPage from "@/pages/Agent/AgentDashboardPage.vue";
import AgentFilesPage from "@/pages/Agent/AgentFilesPage.vue";
import SuperviseurDashboardPage from "@/pages/Superviseur/SuperviseurDashboardPage.vue";
import SuperviseurValidationPage from "@/pages/Superviseur/SuperviseurValidationPage.vue";
import EditAddBescStep1Page from "@/pages/BESC/EditAddBescStep1Page.vue";
import EditAddBescStep3Page from "../pages/BESC/EditAddBescStep3Page.vue";
import EditAddBescStep2Page from "@/pages/BESC/EditAddBescStep2Page.vue";
import TransitaireDashboardPage from "@/pages/Transitaire/TransitaireDashboardPage.vue";
import TransitaireDossiersPage from "@/pages/Transitaire/TransitaireDossiersPage.vue";
import ViewBescByQueuePage from "@/pages/BESC/ViewBescByQueuePage.vue";

const routes = [
  {
    path: "/",
    redirect: "/login",
    component: () => import("@/layouts/MainLayout.vue"),
    meta: {
      middleware: "auth",
    },
    children: [
      {
        path: "/Accueil",
        name: "EcommercePage",
        component: EcommercePage,
      },
      {
        path: "/liste-privileges",
        name: "ListePermissionPage",
        component: ListePermissionPage,
      },
      {
        path: "/ajouter-role",
        name: "AddRolePage",
        component: AddRolePage,
      },
      {
        path: "/modifier-role/:id",
        name: "EditRolePage",
        component: EditRolePage,
      },
      {
        path: "/liste-roles",
        name: "ListeRolePage",
        component: ListeRolePage,
      },
      {
        path: "/view-role/:id",
        name: "ViewRolePage",
        component: ViewRolePage,
      },
      {
        path: "/ajouter-user",
        name: "AddUserPage",
        component: AddUserPage,
      },
      {
        path: "/modifier-user/:id",
        name: "EditUserPage",
        component: EditUserPage,
      },
      {
        path: "/liste-users",
        name: "ListeUserPage",
        component: ListeUserPage,
      },
      {
        path: "/view-user/:id",
        name: "ViewUserPage",
        component: ViewUserPage,
      },
      {
        path: "/profile",
        name: "ProfilePage",
        component: ProfilePage,
      },

      {
        path: "/Parametres",
        name: "AddParametrePage",
        component: AddParametrePage,
      },
      {
        path: "/liste-documents",
        name: "ListeDocumentPage",
        component: ListeDocumentPage,
      },

      {
        path: "/liste-compagnies",
        name: "ListeCompagnie",
        component: ListeCompagniePage,
      },
      {
        path: "/transitaire-dashboard",
        name: "TransitaireDashboard",
        component: TransitaireDashboardPage,
      },
      {
        path: "/transitaire-dossiers",
        name: "TransitaireDossiers",
        component: TransitaireDossiersPage,
      },
      {
        path: "/liste-vessels",
        name: "ListeVessel",
        component: ListeVesselPage,
      },

      {
        path: "/ajouter/etape-1/:id?",
        name: "AddBescStep1",
        component: AddBescStep1Page,
      },
      {
        path: "/ajouter/etape-2/:id",
        name: "AddBlStep2",
        component: AddBlStep2Page,
      },

      // {
      //   path: "/ajouter/etape-3/:id",
      //   name: "AddBescStep2",
      //   component: AddBescStep2Page
      // },

      {
        path: "/ajouter/etape-3/:id",
        name: "AddBescStep3",
        component: AddBescStep3Page,
      },
      {
        path: "/editstep3/:id",
        name: "EditAddBescStep3",
        component: EditAddBescStep3Page,
      },
      {
        path: "/bescRecap/:id",
        name: "Recapitulatif",
        component: RecapitulatifPage,
      },
      {
        path: "/editStep1/:id",
        name: "EditAddBescStep1",
        component: EditAddBescStep1Page,
      },
      {
        path: "/editStep2/:id",
        name: "EditAddBescStep2",
        component: EditAddBescStep2Page,
      },
      {
        path: "/liste-besc",
        name: "ListeBesc",
        component: ListeBescPage,
      },

      {
        path: "/view-besc/:id",
        name: "ViewBesc",
        component: ViewBescPage,
      },

      {
        path: "/payer-besc/:id",
        name: "PaiementMethodePage",
        component: PaiementMethodePage,
      },

      {
        path: "/paiement-paypal/:id",
        name: "PaiementPaypalPage",
        component: PaiementPaypalPage,
      },

      {
        path: "/paiement-stripe/:id",
        name: "PaiementStripePage",
        component: PaiementStripePage,
      },

      {
        path: "/paiement-kkiapay/:id",
        name: "PaiementKKiaPayPage",
        component: PaiementKKiaPayPage,
      },

      {
        path: "/paiement-success",
        name: "PaiementSuccessPage",
        component: PaiementSuccessPage,
      },

      {
        path: "/pageSoumissionBesc",
        name: "PageSoumissionBescePage",
        component: PageSoumissionBescPage,
      },

      {
        path: "/changepassword",
        name: "ResetPasswordPage",
        component: ResetPasswordPage,
      },

      {
        path: "/profile",
        name: "ProfilePage",
        component: ProfilePage,
      },

      {
        path: "/tableau_bord",
        name: "tableauBordPage",
        component: EcommercePage,
      },
      {
        path: "/listeIncoterm",
        name: "ListeIncotermPage",
        component: ListeIncotermPage,
      },
      {
        path: "/listetypedocument",
        name: "ListeTypeDocumentPage",
        component: ListeTypeDocumentPage,
      },
      {
        path: "/addTypedocument",
        name: "AddTypeDocumentPage",
        component: AddTypeDocumentPage,
      },
      {
        path: "/listetypeacteur",
        name: "ListeTypeActeurPage",
        component: ListeTypeActeurPage,
      },
      {
        path: "/addTypeActeur",
        name: "AddTypeActeurPage",
        component: AddTypeActeurPage,
      },
      {
        path: "/listetarification",
        name: "ListeTarificationPage",
        component: ListeTarificationPage,
      },
      {
        path: "/addTarification",
        name: "AddTarificationPage",
        component: AddTarificationPage,
      },

      // Zone tarifaire

      {
        path: "/listeTariffZone",
        name: "ListeTariffZonePage",
        component: ListeTariffZonePage,
      },

      {
        path: "/addTariffZone",
        name: "AddTariffZonePage",
        component: AddTariffZonePage,
      },

      {
        path: "/editTariffZone/:id",
        name: "EditTariffZonePage",
        component: EditTariffZonePage,
      },

      {
        path: "/viewTariffZone/:id",
        name: "ViewTariffZonePage",
        component: ViewTariffZonePage,
      },

      // règles de tarificaton

      {
        path: "/listeBescPricingRule",
        name: "ListeBescPricingRulePage",
        component: ListeBescPricingRulePage,
      },

      {
        path: "/addBescPricingRule",
        name: "AddBescPricingRulePage",
        component: AddBescPricingRulePage,
      },

      {
        path: "/editBescPricingRule/:id",
        name: "EditBescPricingRulePage",
        component: EditBescPricingRulePage,
      },
      {
        path: "/viewBescPricingRule/:id",
        name: "ViewBescPricingRulePage",
        component: ViewBescPricingRulePage,
      },

      // comptes prépayés

      {
        path: "/listePrepaidAccount",
        name: "ListePrepaidAccount",
        component: ListePrepaidAccountPage,
      },

      {
        path: "/addPrepaidAccount",
        name: "AddPrepaidAccount",
        component: AddPrepaidAccountPage,
      },

      {
        path: "/rechargePayPal",
        name: "RechargePayPal",
        component: RechargePayPalPage,
      },

      {
        path: "/rechargeStripe",
        name: "RechargeStripe",
        component: RechargeStripePage,
      },

      {
        path: "/rechargeKkiaPay",
        name: "RechargeKkiaPay",
        component: RechargeKkiaPayPage,
      },

      {
        path: "/PrepaidRechargeSuccess",
        name: "PrepaidRechargeSuccess",
        component: PrepaidRechargeSuccessPage,
      },
      {
        path: "/addvalidationTask",
        name: "AddValidationTaskPage",
        component: AddValidationTaskPage,
      },
      {
        path: "/listevalidationtasks",
        name: "ListeValidationTaskPage",
        component: ListeValidationTaskPage,
      },

      {
        path: "/addvalidationCheck",
        name: "AddValidationCheckPage",
        component: AddValidationCheckPage,
      },
      {
        path: "/listevalidationchecks",
        name: "ListeValidationCheckPage",
        component: ListeValidationCheckPage,
      },
      {
        path: "/affectation/:id",
        name: "AffectationPage",
        component: AffectationPage,
      },
      {
        path: "/retirer/:validationQueueId",
        name: "RetirerAgentPage",
        component: RetirerAgentPage,
        props: true,
      },
      {
        path: "/listeAffectation",
        name: "ListeAffectationPage",
        component: ListeAffectationPage,
      },
      {
        path: "/addvalidationQueue",
        name: "AddValidationQueuePage",
        component: AddValidationQueuePage,
      },
      {
        path: "/listevalidationqueue",
        name: "ListeValidationQueuePage",
        component: ListeValidationQueuePage,
      },
      {
        path: "/editqueue/:id",
        name: "EditValidationQueuePage",
        component: EditValidationQueuePage,
      },
      {
        path: "/editcheck/:id",
        name: "EditValidationCheckPage",
        component: EditValidationCheckPage,
      },
      {
        path: "/edittask/:id",
        name: "EditValidationTaskPage",
        component: EditValidationTaskPage,
      },
      {
        path: "/addcorrectionRequest",
        name: "AddCorrectionRequestPage",
        component: AddCorrectionRequestPage,
      },
      {
        path: "/editcorrection/:id",
        name: "EditCorrectionRequestPage",
        component: EditCorrectionRequestPage,
      },
      {
        path: "/listecorrectionrequests",
        name: "ListeCorrectionRequestPage",
        component: ListeCorrectionRequestPage,
      },
      {
        path: "/addTypeCargaison",
        name: "AddTypeCargaisonPage",
        component: AddTypeCargaisonPage,
      },
      {
        path: "/addcategProduit",
        name: "AddCategoriePPage",
        component: AddCategoriePPage,
      },
      {
        path: "/listecategProduit",
        name: "ListeCategoriePPage",
        component: ListeCategoriePPage,
      },
      // {
      //   path: "/listecontainer",
      //   name: "ListeContainerPage",
      //   component: ListeContainerPage
      // },
      // {
      //    path: "addContainer",
      //    name: "AddContainerPage",
      //    component: AddContainerPage
      // },
      {
        path: "addregimeDouanier",
        name: "AddRegimePage",
        component: AddRegimePage,
      },
      {
        path: "listeregime",
        name: "ListeRegimePage",
        component: ListeRegimePage,
      },
      {
        path: "/listetypecargaison",
        name: "ListeTypeCargaisonPage",
        component: ListeTypeCargaisonPage,
      },
      {
        path: "/listetypecontainer",
        name: "ListeTypeContainerPage",
        component: ListeTypeContainerPage,
      },
      {
        path: "/addTypeContainer",
        name: "AddTypeContainerPage",
        component: AddTypeContainerPage,
      },
      {
        path: "/addTypeChargement",
        name: "AddTypeChargementPage",
        component: AddTypeChargementPage,
      },
      {
        path: "/listetypechargement",
        name: "ListeTypeChargementPage",
        component: ListeTypeChargementPage,
      },
      {
        path: "/addfretpaiement",
        name: "AddTypeFretPaiePage",
        component: AddTypeFretPaiePage,
      },
      {
        path: "/listetypefretpaiement",
        name: "ListeTypeFretPaiePage",
        component: ListeTypeFretPaiePage,
      },
      {
        path: "/addIncoterm",
        name: "AddIncotermPage",
        component: AddIncotermPage,
      },
      {
        path: "/addzonebesc",
        name: "AddZonePage",
        component: AddZonePage,
      },
      {
        path: "/listezone",
        name: "ListeZonePage",
        component: ListeZonePage,
      },
      {
        path: "/liste-ports",
        name: "ListePortPage",
        component: ListePortPage,
      },
      {
        path: "/liste_ports_a_risque",
        name: "ListePortARisquePage",
        component: ListePortARisquePage,
      },

      {
        path: "/listeTableauIMDG",
        name: "ListeTableauIMDGPage",
        component: ListeTableauIMDGPage,
      },
      {
        path: "/listeCategorie_hs_Code",
        name: "ListeCategorieHsCodePage",
        component: ListeCategorieHsCodePage,
      },
      {
        path: "/listeHs_Code",
        name: "ListeHsCodePage",
        component: ListeHsCodePage,
      },

      {
        path: "/listeAgentC",
        name: "ListeAgentConsignatairePage",
        component: ListeAgentConsignatairePage,
      },

      {
        path: "/liste-manifests",
        name: "ListeManifestPage",
        component: ListeManifestPage,
      },
      {
        path: "/upload-manifest",
        name: "UploadManifestPage",
        component: UploadManifestPage,
      },
      {
        path: "/view-manifest/:id",
        name: "ViewManifestPage",
        component: ViewManifestPage,
      },
      

      {
        path: "/view-equiMarchand/:id",
        name: "ViewEquipMarchandPage",
        component: ViewEquipMarchandPage,
      },

      {
        path: "/listeBlacklist",
        name: "ListeBlacklistPage",
        component: ListeBlacklistPage,
      },

      {
        path: "/ajouter-ruleSet",
        name: "AddRuleSetPage",
        component: AddRuleSetPage,
      },
      {
        path: "/modifier-ruleset/:id",
        name: "EditRuleSetPage",
        component: EditRuleSetPage,
      },

      {
        path: "/listeRuleSet",
        name: "ListeRuleSetPage",
        component: ListeRuleSetPage,
      },

      {
        path: "/ajouter-rule",
        name: "AddRulePage",
        component: AddRulePage,
      },
      {
        path: "/modifier-rule/:id",
        name: "EditRulePage",
        component: EditRulePage,
      },
      {
        path: "/listeRule",
        name: "ListeRulePage",
        component: ListeRulePage,
      },
      {
        path: "/ajouter-ProduitRestreint",
        name: "AddProduitRestreintPage",
        component: AddProduitRestreintPage,
      },
      {
        path: "/modifierpr/:id",
        name: "EditProduitRestreintPage",
        component: EditProduitRestreintPage,
      },

      {
        path: "/listeProduitRestreint",
        name: "ListeProduitRestreintPage",
        component: ListeProduitRestreintPage,
      },

      {
        path: "/detailFile",
        name: "DetailFilePage",
        component: DetailFilePage,
      },

      // Routes Agent
      {
        path: "/agent-dashboard",
        name: "AgentDashboardPage",
        component: AgentDashboardPage,
      },
      {
        path: "/agent-files",
        name: "AgentFilesPage",
        component: AgentFilesPage,
      },

      // Routes Superviseur
      {
        path: "/superviseur-dashboard",
        name: "SuperviseurDashboardPage",
        component: SuperviseurDashboardPage,
      },
      {
        path: "/superviseur-validation",
        name: "SuperviseurValidationPage",
        component: SuperviseurValidationPage,
      },

      //    {
      //   path: "/view-vessel/:id",
      //   name: "ViewVesselPage",
      //   component: ViewVesselPage,
      // },

      {
        path: "/project-management",
        name: "ProjectManagementPage",
        component: ProjectManagementPage,
      },
      {
        path: "/support-desk",
        name: "SupportDeskPage",
        component: SupportDeskPage,
      },
      {
        path: "/lms-courses",
        name: "LMSCoursesPage",
        component: LMSCoursesPage,
      },
      {
        path: "/crm-system",
        name: "CRMSystemPage",
        component: CRMSystemPage,
      },
      {
        path: "/file-manager",
        name: "FileManagerPage",
        component: FileManagerPage,
      },
      {
        path: "/changelog",
        name: "ChangelogPage",
        component: ChangelogPage,
      },
      {
        path: "/calendar",
        name: "CalendarPage",
        component: CalendarPage,
      },
      {
        path: "/chat",
        name: "ChatPage",
        component: ChatPage,
      },
      {
        path: "/chat-group",
        name: "ChatGroupPage",
        component: ChatGroupPage,
      },
      {
        path: "/chat-contact",
        name: "ChatContactPage",
        component: ChatContactPage,
      },
      {
        path: "/leads",
        name: "LeadsPage",
        component: LeadsPage,
      },
      {
        path: "/lead-details",
        name: "LeadDetailsPage",
        component: LeadDetailsPage,
      },
      {
        path: "/crm-contacts",
        name: "ContactsListPage",
        component: ContactsListPage,
      },
      {
        path: "/crm-customers",
        name: "CustomersListPage",
        component: CustomersListPage,
      },
      {
        path: "/emails",
        name: "EmailsPage",
        component: EmailsPage,
      },
      {
        path: "/read-email",
        name: "ReadEmailPage",
        component: ReadEmailPage,
      },
      {
        path: "/products",
        name: "ProductsGridPage",
        component: ProductsGridPage,
      },

      {
        path: "/orders",
        name: "OrdersListPage",
        component: OrdersListPage,
      },
      {
        path: "/order-details",
        name: "OrderDetailsPage",
        component: OrderDetailsPage,
      },
      {
        path: "/cart",
        name: "ShoppingCartPage",
        component: ShoppingCartPage,
      },
      {
        path: "/checkout",
        name: "CheckoutPage",
        component: CheckoutPage,
      },
      {
        path: "/customers",
        name: "CustomersPage",
        component: CustomersPage,
      },
      {
        path: "/sellers",
        name: "SellersListPage",
        component: SellersListPage,
      },
      {
        path: "/reviews",
        name: "ManageReviewsPage",
        component: ManageReviewsPage,
      },
      {
        path: "/refund",
        name: "RefundPage",
        component: RefundPage,
      },
      {
        path: "/invoice",
        name: "InvoiceListPage",
        component: InvoiceListPage,
      },
      {
        path: "/invoice-details",
        name: "InvoiceDetailsPage",
        component: InvoiceDetailsPage,
      },
      {
        path: "/order-tracking",
        name: "OrderTrackingPage",
        component: OrderTrackingPage,
      },
      {
        path: "/courses-list",
        name: "CoursesListPage",
        component: CoursesListPage,
      },
      {
        path: "/courses-grid",
        name: "CoursesGridPage",
        component: CoursesGridPage,
      },
      {
        path: "/course-details",
        name: "CourseDetailsPage",
        component: CourseDetailsPage,
      },
      {
        path: "/lessons-preview",
        name: "LessonsPreviewPage",
        component: LessonsPreviewPage,
      },
      {
        path: "/edit-course",
        name: "EditCoursePage",
        component: EditCoursePage,
      },
      {
        path: "/support-desk-list",
        name: "ListViewPage",
        component: ListViewPage,
      },
      {
        path: "/support-desk-card",
        name: "CardViewPage",
        component: CardViewPage,
      },
      {
        path: "/contacts",
        name: "ContactsPage",
        component: ContactsPage,
      },
      {
        path: "/ticket-preview",
        name: "TicketPreviewPage",
        component: TicketPreviewPage,
      },
      {
        path: "/projects-list",
        name: "ProjectsListPage",
        component: ProjectsListPage,
      },
      {
        path: "/projects-grid",
        name: "ProjectsGridPage",
        component: ProjectsGridPage,
      },
      {
        path: "/create-new-project",
        name: "CreateNewProjectPage",
        component: CreateNewProjectPage,
      },
      {
        path: "/project-details",
        name: "ProjectDetailsPage",
        component: ProjectDetailsPage,
      },
      {
        path: "/to-do-list",
        name: "ToDoListPage",
        component: ToDoListPage,
      },
      {
        path: "/projects-teams",
        name: "TeamsPage",
        component: TeamsPage,
      },
      {
        path: "/kanban",
        name: "KanbanPage",
        component: KanbanPage,
      },
      {
        path: "/events",
        name: "EventsGridPage",
        component: EventsGridPage,
      },
      {
        path: "/event-details",
        name: "EventDetailsPage",
        component: EventDetailsPage,
      },
      {
        path: "/social-timeline",
        name: "TimelinePage",
        component: TimelinePage,
      },
      {
        path: "/social-about",
        name: "AboutPage",
        component: AboutPage,
      },
      {
        path: "/social-activity",
        name: "ActivityPage",
        component: ActivityPage,
      },
      {
        path: "/profile-settings",
        name: "ProfileSettingsPage",
        component: ProfileSettingsPage,
      },
      {
        path: "/starter",
        name: "StarterPage",
        component: StarterPage,
      },

      {
        path: "/users-list",
        name: "UsersListPage",
        component: UsersListPage,
      },

      {
        path: "/pricing",
        name: "PricingPage",
        component: PricingPage,
      },
      {
        path: "/faq",
        name: "FaqPage",
        component: FaqPage,
      },
      {
        path: "/ui-swiper-slider",
        name: "SwiperSliderPage",
        component: SwiperSliderPage,
      },
      {
        path: "/privacy-policy",
        name: "PrivacyPolicyPage",
        component: PrivacyPolicyPage,
      },
      {
        path: "/terms-conditions",
        name: "TermsConditionsPage",
        component: TermsConditionsPage,
      },
      {
        path: "/forms-overview",
        name: "FormOverviewPage",
        component: FormOverviewPage,
      },
      {
        path: "/forms-form-control",
        name: "FormControlPage",
        component: FormControlPage,
      },
      {
        path: "/forms-select",
        name: "FormSelectPage",
        component: FormSelectPage,
      },
      {
        path: "/forms-checks-radios",
        name: "FormChecksRadiosPage",
        component: FormChecksRadiosPage,
      },

      {
        path: "/blank-page",
        name: "BlankPage",
        component: BlankPage,
      },
      {
        path: "/logout",
        name: "LogoutPage",
        component: LogoutPage,
      },
    ],
  },
  {
    path: "/",
    redirect: "/login",
    component: () => import("@/layouts/AuthLayout.vue"),
    children: [
      {
        path: "/login",
        name: "LoginPage",
        component: LoginPage,
      },
    ],
  },
  { path: "/:pathMatch(.*)*", name: "ErrorPage", component: ErrorPage },
];

const router = createRouter({
  //history: createWebHistory(),
  history: createWebHistory(process.env.BASE_URL),
  linkExactActiveClass: "active",
  routes: routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

// router.beforeEach(async (to, from, next) => {
//   const authStore = useAuthStore();
//   // await authStore.verifyAuth();
//   if(to.meta.middleware == "auth") {
//     ApiService.setHeader();
//     if (authStore.isAuthenticated) {
//       next();
//     } else {
//       next({ name: "LoginPage" });
//       next();
//     }
//   } else {
//     next();
//   }
//   // Scroll page to top on every route change
//   window.scrollTo({
//     top: 0,
//     left: 0,
//     behavior: "smooth",
//   });
// });

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();

  // authStore.verifyAuth();

  if (to.meta.middleware == "auth") {
    // console.log("aaronnnn");
    ApiService.setHeader();
    if (authStore.isAuthenticated) {
      next();
    } else {
      // next({ name: "LoginPage" });
      next();
    }
  } else {
    // console.log("AARONNN");
    next();
  }

  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
});

export default router;
